<template>
  <div>
    <v-alert :value="erroreAllineamento" dismissible prominent dense type="warning">Attenzione! I numeratori in cloud non risultano allineati! Aprire la pagina Home per riallineare.</v-alert>    
    <v-data-table
      v-model="selected"
      :show-select="totaleDocumenti > 0"
      item-key="_id"
      :headers="headers"
      :items="documenti"
      :options.sync="options"
      :server-items-length="totaleDocumenti"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50, 100]
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :show-expand="false"
      dense
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ title || 'Documenti' }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn color="primary" dark class="mb-2" @click="onNuovoDocumento">Nuovo Documento</v-btn> -->
        <v-btn v-if="abilitaOrdineMultiplo" :disabled="erroreAllineamento" color="orange darken-1 white--text" class="mb-2 mr-5" @click="onNuovoMultiplo">Nuovo Ordine Multiplo</v-btn>
        <v-btn color="success" :disabled="erroreAllineamento" class="mb-2 mr-5" @click="onNuovoOrdine">Nuovo Ordine Fornitore</v-btn>
        <v-btn color="primary" :disabled="erroreAllineamento" class="mb-2" @click="onNuovoDdt">Nuovo DDT Fornitore</v-btn>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Confermi cancellazione documento ?</v-card-title>
            <v-card-subtitle>Vengono eliminati anche i movimenti collegati</v-card-subtitle>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
              <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <dialog-errore :show="dialogErrore" :title="errorTitle" :message="errorMessage" @dialogConfirm="dialogErrore = false"/>
        <dialog-stampa
          :show="dialogStampa"
          title="Stampa Etichette"
          confirmText="Stampa"
          cancelText="Annulla"
          :totaleEtichette="totaleEtichette"
          :isStampaEtichette="true"
          :isModuloA4="isModuloA4"
          @dialog-print="onDialogPrint"
          @dialog-cancel="onDialogCancel"
        />        
      </v-toolbar>
      <filtri :filtraTipiDocumento="filtroTipiDocumento" @ricerca="onRicerca"/>
    </template>
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data | dateTime }}
    </template>
    <template v-slot:[`item.actions`]="{ item }">
<!--       <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="editItem(item, false)" v-bind="attrs" v-on="on">mdi-pencil</v-icon>
        </template>
        <span>Modifica il movimento</span>
      </v-tooltip> -->
      <v-icon v-if="abilitaCancellazione" small class="mr-2" @click="deleteItemWithPassword(item)" title="Cancella documento e movimenti collegati" color="red">mdi-delete</v-icon>
      <v-icon small class="mr-2" @click="editItem(item, false)" title="Modifica il movimento">mdi-pencil</v-icon>
      <v-icon small class="mr-2" @click="stampaDocumento(item)" :title="giaStampato(item) ? 'Il documento è stato già stampato' : 'Stampa Documento'" :color="giaStampato(item) ? 'green' : ''">mdi-printer-outline</v-icon>     
      <v-icon small class="mr-2" v-if="abilitaInvioEmail(item)" @click="emailDocumento(item)" :title="giaInviata(item) ? 'Email già inviata' : 'Invia email'" :color="giaInviata(item) ? 'green' : ''">mdi-email-outline</v-icon>
<!--       <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="stampaDocumento(item)" v-bind="attrs" v-on="on">mdi-printer-outline</v-icon>
        </template>
        <span>Stampa Documento</span>
      </v-tooltip> -->
      <v-menu v-if="destinazioni(item).length > 0">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="{ ...tooltip, ...menu }">mdi-content-duplicate</v-icon>
            </template>
            <span>Trasforma Ordine</span>
          </v-tooltip>
        </template>
        <v-list>
          <template v-for="(m, index) in destinazioni(item)">
            <v-list-item :key="index">
              <v-list-item-title><v-btn text @click="trasformaIn(m, item)">{{m.descrizione}}</v-btn></v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
      <v-tooltip bottom v-if="item.stato && (item.stato.codice === 'chiuso' || item.stato.codice === 'ordiniCreati')">
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="onSbloccaDocumento(item)" v-bind="attrs" v-on="on">mdi-lock-off-outline</v-icon>
        </template>
        <span>Sblocca Documento</span>
      </v-tooltip>
      <v-icon v-if="mostraIconaTabacchi(item)" small class="mr-2" @click="esportaTabacchi(item)" title="Esporta Excel Tabacchi">mdi-smoke</v-icon>          
    </template> 
    <template v-slot:no-data>
      Nessun dato disponibile
    </template>
    </v-data-table>
    <speed-dial @comando="onSpeedDialogComando"/>
    <ordine-multiplo-fornitore v-if="abilitaOrdineMultiplo" :showDialog="showOrdineMultiplo" :nuovoDocumento="nuovoDocumento" :idDocumento="idDocumento" :filtraTipiDocumento="filtraTipiDocumento" :readOnly="readOnly" :trigger="triggerUpdate" @refresh="getDataFromApi"/>
    <edit-ordine-fornitore :showDialog="showEditDocumento" :nuovoDocumento="nuovoDocumento" :idDocumento="idDocumento" :filtraTipiDocumento="filtraTipiDocumento" :readOnly="readOnly" :trigger="triggerUpdate" @refresh="getDataFromApi"/>
    <edit-ddt-fornitore :showDialog="showEditDdtFornitore" :nuovoDocumento="nuovoDocumento" :idDocumento="idDocumento" :filtraTipiDocumento="filtraTipiDocumento" :readOnly="readOnly" :trigger="triggerUpdate" @refresh="getDataFromApi"/>
    <dialog-conferma
      :show="dialogConferma"
      :title="titoloConferma"
      :message="messaggioConferma"
      @dialog-confirm="onConferma"
      @dialog-cancel="dialogConferma=false"
    />
  </div>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import { dynamicSortMultiple, slugify, downloadZip, getAnnoRiferimento } from '@/components/helpers.js'
  import JSZip from 'jszip'
  import DialogErrore from '@/components/dialogErrore'
  import DialogConferma from '@/components/dialogConferma'
  import DialogStampa from '@/components/dialogStampa'
  import Filtri from './testate_filtri'
  import EditOrdineFornitore from './edit/editDocumento'
  import EditDdtFornitore from './edit/editDdtFornitore'
  import SpeedDial from '../../documenti/components/speedDial.vue'
  import OrdineMultiploFornitore from './edit/ordineMultiploFornitore'
  import configurazioni from '@/services/configurazioniService.js'
  import prodotti from '@/services/prodottiService.js'
  import clienti from '@/services/clientiService.js'
  import documenti from '@/services/documentiService.js'
  import magazzino from '@/services/magazzinoService.js'
  import reporting from '@/services/reportingService.js'
  import excelService from '@/services/excelService.js'
  import etichetteService from '@/services/etichetteService.js'
  import emailService from '@/services/emailService.js'
  import { printed } from '@/helpers/printed.js'
  import { emailed, buildDestinatario, buildOggetto } from '@/helpers/emailed.js'
  const labelsPath = window.appConfig.VUE_APP_MOL_S_LABELS

  export default {
    components: {
      DialogErrore,
      DialogConferma,
      DialogStampa,
      SpeedDial,
      Filtri,
      EditOrdineFornitore,
      EditDdtFornitore,
      OrdineMultiploFornitore
    },
    props: {
      filtraTipiDocumento: Array,
      title: String,
      hideRiepilogativa: Boolean
    },
    data (vm) {
      return {
        totaleDocumenti: 0,
        documenti: [],
        selected: [],
        loading: true,
        options: {
          itemsPerPage: 25
        },
        headers: [
          { text: 'Tipo', value: 'tipoDocumento.descrizione', align: 'start'},
          { text: 'Numero', value: '_id'},
          { text: 'Data', value: 'data' },
          { text: 'Riferimento', value: 'info.numeroDocumento' },
          { text: 'Nominativo', value: 'd_nominativo' },
          { text: 'Stato', value: 'stato.descrizione' },
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        usaQtaAnagrafica: false,
        // salta: 0,
        tipoStampa: '',
        report: '',
        isModuloA4: false,
        errorTitle: 'Errore aggiornamento Documento',
        errorMessage: '',
        showDialogMultiple: false,
        showDettaglioFattura: false,
        triggerUpdate: 1,
        idDocumento: null,
        showEditDocumento: false,
        showEditDdtFornitore: false,
        showOrdineMultiplo: false,
        readOnly: false,
        nuovoDocumento: false,
        statoRicevuto: { codice: 'ricevuto', descrizione: 'ricevuto' },
        dialogConferma: false,
        itemSblocco: null,
        titoloConferma: '',
        messaggioConferma: '',
        onConferma: vm.onSbloccaDocumento,
        abilitaCancellazione: false,
        codiceCancellazione: '0000',
        abilitaOrdineMultiplo: false,
        infoEmail: null,
        erroreAllineamento: false
      }
    },
    async created() {
      this.pathEtichettePrefix = window.appConfig.VUE_APP_MOL_API_GATEWAY || ''
      await this.getDefaultItem()
      if (this.$route.query.debug && this.$route.query.debug === 'true') {
        this.abilitaCancellazione = true
      }
      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.abilitaOrdineMultiplo = _.get(impostazioni, 'fornitori.ordineMultiplo', false)
      if (_.get(impostazioni, 'cancellazioni.documentiFornitore')) {
        this.abilitaCancellazione = true
      }
      const email = _.get(impostazioni, 'email')
      this.infoEmail = email      
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuovo Documento' : 'Modifica Documento'
      },
      documentiSaved() {
        return this.$store.getters['documenti/saved']
      },
      testataAperta() {
        return this.$store.getters['documenti/page'] === 'testata'
      },
      refreshList() {
        // console.log('refreshList')
        return this.$store.getters['documenti/refreshTestata']
      },
      documentiSorted() {
        const els = this.documenti
        const elSorted = els.sort(dynamicSortMultiple('-_id'))
        return elSorted
      },
      totaleEtichette() {
        const elSel = this.selected
        if (elSel.length > 0) {
          const totaleAnagrafica = _.sum(elSel.map(x => x.qtaAnagrafica))
          const totaleDocumenti = _.sum(elSel.map(x => x.qtaDocumenti))
          return { totaleAnagrafica, totaleDocumenti }
        } else {
          return { totaleAnagrafica: 0, totaleDocumenti: 0 }
        }
      },
      filtroTipiDocumento() {
        return this.filtraTipiDocumento && this.filtraTipiDocumento.length > 0 ? this.filtraTipiDocumento.map(x => x.tipoDocumento) : []
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      async documentiSaved(value) {
        if (value && this.testataAperta) {
          await this.save()
        }
      },
      async refreshList(value) {
        if (value) {
          this.options.page = 1
          await this.getDataFromApi()
          this.$store.commit('documenti/CLEAR_REFRESH', 'testata')
        }
      },
      async filtraTipiDocumento() {
        await this.getDataFromApi()
      }      
    },
    async mounted () {
      const verificaNumeratori = await configurazioni.verificaAllineamentoNumeratori()
      if (!['ok', '---'].includes(verificaNumeratori.status)) {
        this.erroreAllineamento = true
      }
    },
    methods: {
      abilitaInvioEmail(item) {
        if (!this.infoEmail) return false
        const info = this.infoEmail.find(x => x.tipiDocumento.includes(item.tipoDocumento.tipoDocumento))
        return info ? info.abilitaInvioEmail : false
      },      
      mostraIconaTabacchi(item) {
        return !!(item && item.tipoDocumento && item.tipoDocumento.tabacchi)
      },
      deleteItemWithPassword(item) {
        if (prompt('inserire codice per cancellazione') === this.codiceCancellazione) {
          this.deleteItem(item)
        }
      },
      deleteItem (item) {
        this.editedIndex = this.documenti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      async deleteItemConfirm () {
        this.documenti.splice(this.editedIndex, 1)
        const doc = this.editedItem
        await magazzino.cancellaPerRiferimento('documento', doc._id, doc.data)        
        await documenti.cancellaDocumento(doc._id)        
        this.closeDelete()
      },      
      destinazioni(item) {
        // in base al tipo documento ed al suo stato, determino quali possono essere i documenti di destinazione
        const destinazioni = []
        switch (item.tipoDocumento.tipoDocumento) {
          case "ordineFornitore":
            // verificare se lo stato è aperto, parziale, sospeso o chiuso
            if (!item.stato || ['aperto', 'parziale'].includes(item.stato.codice)) {
              destinazioni.push({ codice: 'ddtFornitore', descrizione: 'Crea DDT fornitore' })
            }
            break
          default:
            break
        }
        return destinazioni
      },
/*       onSceltaRighe(elenco) {

      }, */
      isFattura(item) {
        return item.tipoDocumento.xml
      },
      async getDefaultItem() {
        this.defaultItem = await documenti.getModello('xxx')
        this.defaultItem.data = new Date()
      },
      async stampaDocumento(item) {
        try {
          const result = await reporting.stampaDocumento(this.$router, item, true, true)
          if (result && result.error) {
            console.log(result.error)
          } else {
            await printed(item._id)
            await this.getDataFromApi()
          }
        } catch {}
      },
      giaStampato(item) {
        const pr = _.get(item, 'editInfo.printed')
        return pr && pr.length > 0 
      },
      giaInviata(item) {
        const em = _.get(item, 'editInfo.emailed')
        return em && em.length > 0 
      },      
      async emailDocumento(item) {
        try {
          let infoEmail = this.infoEmail.find(x => x.tipiDocumento.includes(item.tipoDocumento.tipoDocumento))
          if (!infoEmail) return
          const tipoDestinatario = infoEmail.emailInvio || 'pec'
          const tipoCc = infoEmail.emailCc || ''  
          
          const fornitore = await clienti.getCliente(item.anagrafica.fornitore.codice)
          const destinatario = buildDestinatario(fornitore, tipoDestinatario)
          if (destinatario.length === 0) {
            this.errorTitle = 'Invio email non possible !'
            this.errorMessage = 'Non è stata trovata una email valida per il destinatario.<br />Valore cercato: ' + tipoDestinatario
            this.dialogErrore = true            
            return
          }
          const result = await reporting.stampaDocumento(this.$router, item, true, true, null, 'base64')
          if (result && result.error) {
            console.log(result.error)
          } else {

            const copiaCarbone = buildDestinatario(fornitore, tipoCc)
            const allegati = [{
              content: result,
              filename: 'documento.pdf',
              type: 'application/pdf',
              disposition: 'attachment'
            }]
            infoEmail.oggetto = buildOggetto(item, infoEmail.oggetto)
            if (await emailService.inviaEmail(destinatario, copiaCarbone, infoEmail, allegati)) {
              await emailed(item._id, destinatario, copiaCarbone)
              await this.getDataFromApi()
            }
          }
        } catch(err) {
          console.log('errore', err)
        }
      },
      /* buildDestinatario(item, destinatario) {
        let to = []
        const tdd = destinatario.split(',')
        for (let td of tdd) {
          let nome = ''
          let email = ''
          let sede = null
          switch(td) {
            case 'fatture':
              email = _.get(item, 'fatturazione.emailInvio') || ''
              nome = _.get(item, 'ragioneSociale') || email
              if (email) to.push({ nome, email })
              break
            case 'pec':
              email = _.get(item, 'fatturazione.pec') || ''
              nome = _.get(item, 'ragioneSociale') || email
              if (email) to.push({ nome, email })
              break
            case 'sede':
              sede = item.recapiti ? item.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
              if (sede) {
                email = sede.email || ''
                nome = email  // TODO: Prevedere una Descrizione del recapito
                if (email) to.push({ nome, email })
              }
              break
            case 'recapiti':
              break
            case 'primoCompilato':
              email = _.get(item, 'fatturazione.emailInvio') || ''
              nome = _.get(item, 'ragioneSociale') || email
              if (!email) {
                email = _.get(item, 'fatturazione.pec') || ''
                nome = _.get(item, 'ragioneSociale') || email
              }
              if (!email) {
                sede = item.recapiti ? item.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
                if (sede) {
                  email = sede.email || ''
                  nome = email 
                }
              }
              if (email) to.push({ nome, email })
              break
            case 'tutti':
              email = _.get(item, 'fatturazione.emailInvio') || ''
              nome = _.get(item, 'ragioneSociale') || email
              if (email) to.push({ nome, email })
              email = _.get(item, 'fatturazione.pec') || ''
              nome = _.get(item, 'ragioneSociale') || email
              if (email) to.push({ nome, email })
              sede = item.recapiti ? item.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
              if (sede) {
                email = sede.email || ''
                nome = email
                if (email) to.push({ nome, email })
              }             
              break
            default:
              break
          }   
        }
        return to
      },      */ 
      async onSbloccaDocumento(item) {
        this.titoloConferma = "Richiesta sblocco documento"
        this.messaggioConferma = 'Confermi riapertura documento chiuso ?'
        this.dialogConferma = true
        this.itemSblocco = item
        this.onConferma = this.sbloccaDocumento
      },
      async sbloccaDocumento() {
        this.dialogConferma = false
        const item = this.itemSblocco
        let documento = await documenti.getDocumento(item._id)
        documento.stato = { codice: '', descrizione: '' }
        const result = await documenti.aggiornaDocumento(documento)
        await this.getDataFromApi() 
      },
      async trasformaIn(destinazione, item) {
        const documento = await documenti.getDocumento(item._id)
        if (documento) {
          // documento.stato = 'ricevuto' // ho ricevuto la merce ma devo ancora verificarla
          const elenco = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
          const tipoDestinazione = elenco.find(x => x.codice === destinazione.codice)
          let newDoc = await documenti.trasformaDocumento(documento, tipoDestinazione, this.statoRicevuto)
          this.options.page = 1
          await this.getDataFromApi() 
        }
      },
      async esportaTabacchi(item) {
        const documento = await documenti.getDocumento(item._id)
        const ids = documento.righe.map(x => x.prodotto.codice)
        const pp = await prodotti.getProdottiByIds(ids)
        let dati = []
        for (let r of documento.righe) {
          let p = pp.find(x => x._id === r.prodotto.codice)
          const fabbisogno = parseFloat(r.quantita || r.ordine.ordinato)
          const fabbisognoChili = +(fabbisogno * p.custom.tabacchi.pesoConfezione).toFixed(4)        
          const ord = {
            Codice: p.custom.tabacchi.codiceFornitore,
            Quantità: +fabbisognoChili.toFixed(2)
          }
          dati.push(ord)
        }
        await excelService.creaExcelData(dati, item.tipoDocumento.tabacchi.nomeFile + '.xls')
      }, 
      async onRicerca(filtri) {
        this.filtri = filtri
        this.options.page = 1
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        try {
          this.loading = true
          /*
            Versione per dettaglio riga
            const data = await magazzino.getFilteredMovements(this.filtri, this.options)
            this.documentiRaw = data && data.total_rows > 0 ? data.rows : [] // TODO: valida per la versione modificata. Da adeguare
          */
          const data = await documenti.getFilteredDocumentHeaders(this.filtri, this.options)
          // this.documentiRaw = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
          this.documentiRaw = data && data.total_rows > 0 ? data.rows : []
          // this.documenti = this.datiVisualizzazione(this.documentiRaw)
          this.documentiRaw = this.documentiRaw.filter(x => x.tipoDocumento) // Elimina documenti contabili
          let docs = this.datiVisualizzazione(this.documentiRaw)
          if (this.filtroTipiDocumento && this.filtroTipiDocumento.length > 0) {
            docs = docs.filter(x => this.filtroTipiDocumento.includes(x.tipoDocumento.tipoDocumento))
          }
          this.documenti = docs
 
          // this.documenti = data && data.total_rows > 0 ? data.rows : []
          this.totaleDocumenti = data.total_rows
        } catch(err) {
          this.documenti = []
          this.totaleDocumenti = 0
        } finally {
          this.loading = false
        }
      },
      async onNuovoDocumento() {
        prodotti.clearCache()
        // this.$router.push('v-documenti-edit')
        this.nuovoDocumento = true
        this.idDocumento = null
        this.showEditDocumento = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showEditDocumento = false
      },
      async onNuovoOrdine() {
        prodotti.clearCache()
        _.set(this.locDocumento, 'tipoDocumento.codice', 'ordineFornitore')
        this.nuovoDocumento = true
        this.idDocumento = null
        this.showEditDocumento = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showEditDocumento = false
      },
      async onNuovoDdt() {
        prodotti.clearCache()
        _.set(this.locDocumento, 'tipoDocumento.codice', 'ddtFornitore')
        this.nuovoDocumento = true
        this.idDocumento = null
        this.showEditDdtFornitore = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showEditDdtFornitore = false
      },
      async onNuovoMultiplo() {
        prodotti.clearCache()
        _.set(this.locDocumento, 'tipoDocumento.codice', 'ordineMultiplo')
        this.nuovoDocumento = true
        this.idDocumento = null
        this.showOrdineMultiplo = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showOrdineMultiplo = false
      },   
      async dettaglioItem (item) {
        this.idDocumento = item._id
        this.showDettaglioFattura = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showDettaglioFattura = false

      },
      async editItem (item, readonly) {
        this.idDocumento = item._id
        this.readOnly = readonly
        this.nuovoDocumento = false
        switch (item.tipoDocumento.tipoDocumento) {
          case 'ordineFornitore':
            this.showEditDocumento = true
            break
          case 'ordineMultiplo':
            this.showOrdineMultiplo = true
            break
          case 'ddtFornitore':
            this.showEditDdtFornitore = true
          default:
            this.showEditDdtFornitore = true
            break
        }
/*         if (item.tipoDocumento.tipoDocumento === 'ordineFornitore') {
          this.showEditDocumento = true
        } else {
          this.showEditDdtFornitore = true
        } */
        
        await this.$nextTick()
        this.triggerUpdate++
        this.showEditDocumento = false
        this.showEditDdtFornitore = false
        this.showOrdineMultiplo = false
/*         if (item.tipoDocumento.tipoDocumento === 'ordineFornitore') {
          this.showEditDocumento = false
        } else {
          this.showEditDdtFornitore = false
        }    */   
      },
      async completaAppoggio() {
        let itm = this.editedItem
        _.set(itm,'appoggio.clienteVisibile', itm.tipoDocumento.visualizzaCliente)
        _.set(itm,'appoggio.fornitoreVisibile', itm.tipoDocumento.visualizzaFornitore)
        _.set(itm,'appoggio.spedizioneVisibile', itm.tipoDocumento.infoSpedizione)
        _.set(itm,'appoggio.pagamentoVisibile', itm.tipoDocumento.infoPagamento)
        _.set(itm,'appoggio.tipoDocumento', itm.tipoDocumento)
        const clifor = _.get(itm.anagrafica, 'cliente', '') || _.get(itm.anagrafica, 'fornitore', '')
        _.set(itm,'appoggio.clifor', clifor)
      },      
      close () {
        this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async save () {
        this.$store.commit('documenti/CLEAR_DOCUMENTO_SAVED')
        this.editedItem = this.$store.getters['documenti/documento']
        if (this.editedIndex > -1) {
          // verificare
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          this.editedItem.editInfo.utenteModifica = this.$store.getters.utente
          Object.assign(this.documenti[this.editedIndex], this.editedItem)
          if (!await documenti.aggiornaDocumento(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        } else {
          const numeratore = this.editedItem.tipoDocumento.numeratore
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          this.editedItem.editInfo.utenteCreazione = this.$store.getters.utente
          // sarebbe meglio mettere il numeratore su documenti, ma finchè non c'è molecular fa troppi giri ....
          const annoRiferimento = getAnnoRiferimento(this.editedItem.data) // this.editedItem.data.getFullYear()
          const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
          this.editedItem.codice = numero
          this.editedItem._id = numero
          this.documenti.push(this.editedItem)
          if (!await documenti.creaDocumento(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        }
        this.editedItem = null
        this.editedIndex = -1
        this.close()
        // va fatto il refresh della lista per prendere gli aggiornamenti
        await this.getDataFromApi()
      },
      erroreConfirm() {
        this.dialogErrore = false
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
        const item = options.item
        this.editItem (item)
      },
      datiVisualizzazione(documenti) {
        const elaborati = documenti.map(el => {
          const d_nominativo = el.anagrafica && ((el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)) || ''
          const nominativo = el.anagrafica && ((el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)) || ''
          return { ...el, c_nominativo: nominativo, d_nominativo: d_nominativo  }
        })
        return elaborati
      },
      deleteDatiVisualizzazione(documento) {
        let locDocumento = {...documento}
        delete locDocumento.c_nominativo
        delete locDocumento.d_nominativo
        delete locDocumento.appoggio
        return locDocumento
      },
      async onSpeedDialogComando(comando, payload) {
        switch (comando) {
          case 'stampa-etichette':
            const impostazioni = await configurazioni.getConfigurazione('display_generale', 'etichette')
            this.dialogStampa = true
            break
          case 'stampa-documenti':
            if (this.selected.length > 0) {
              var zip = new JSZip()
              for (let item of this.selected) {
                try {
                  // TODO: Su moleculer fare lato server vedi: const zlib = require('zlib');
                  const pdfFile = await reporting.stampaDocumento(this.$router, item, true, true, false, 'base64')
                  let nomeFile = slugify(item._id) + '.pdf'
                  zip.file(nomeFile, pdfFile, { base64: true });
                  if (pdfFile) {
                    await printed(item._id)
                  }               
                } catch (error) {
                  console.log(error)
                }
              }
              const content = await zip.generateAsync({ type: 'base64' })
              downloadZip(document, 'Stampe.zip', content, true) 
              await this.getDataFromApi()
            }
            break            
          default:
            break
        }
      },
      onDialogCancel() {
        this.dialogStampa = false
      },
      async onDialogPrint(usaQtaAnagrafica, salta, tipoStampa, report, forzaQuantita) {
        this.usaQtaAnagrafica = usaQtaAnagrafica
        // this.salta = salta
        this.dialogStampa = false
        const tipoQuantita = this.usaQtaAnagrafica ? 'anagrafica' : 'movimento'
        const documenti = this.selected
        for (let mm of documenti) {
          const filtriAggiuntivi = [{
            applicazione: 'movimenti',
            chiave: 'riferimento.id',
            testo: _.get(mm, '_id', '')
          }]
          const parametri = {
            articoli: true,
            filtri: filtriAggiuntivi,
            gruppi: [],
            tipoQuantita,
            forzaQuantita
          }
          const filtro = {
            start: moment(mm.data).startOf('day').format('YYYYMMDD'),
            end: moment(mm.data).endOf('day').format('YYYYMMDD')
          }
          const filtroElementi = { filtro, parametri }
          let src = `${labelsPath}/${tipoStampa}/${report}?elm=${btoa(JSON.stringify(filtroElementi))}${salta ? '&sk=' + salta : ''}${tipoQuantita ? '&tpq=' + tipoQuantita : ''}`
          if (forzaQuantita) {
            src += `&fq=${forzaQuantita}`
          }
          
          const printResult = await etichetteService.stampaDiretta(tipoStampa, src)
          if (printResult.status && printResult.status === 'error') {
            this.errorTitle = ' Errore stampa etichette'
            this.errorMessage = printResult.error
            this.dialogErrore = true
          }
        }
        this.annullaSelezione()
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }

</style>
